module.exports = __webpack_public_path__ + "img/bg.499c8cf9.png";